import { Quaternion, Vector3 } from 'three'

// Scene-selected Unity PodGrid values, with the explicit Blender marker replacing its old center offset.
export function courseStationPose(index, marker) {
  const group = Math.floor(index / 4)
  const angle = (index % 4) * Math.PI / 2
  const rotation = new Quaternion().fromArray(marker.quaternion)
  const position = new Vector3((group % 5) * 6 + 0.1 * Math.cos(angle), 0, Math.floor(group / 5) * 6 + 0.1 * Math.sin(angle))
    .applyQuaternion(rotation).add(new Vector3().fromArray(marker.position))
  // The chair sits on the machine's -Z side. Point that side outward after
  // recentering the supplied model on the machine's authoring pivot.
  const facing = new Quaternion().setFromAxisAngle(new Vector3(0, 1, 0), -angle - Math.PI / 2)
  return { position: position.toArray(), quaternion: rotation.multiply(facing).toArray() }
}
export function courseModelOrigin(template) {
  const machine = template.getObjectByName('smily')
  if (!machine) throw new Error('station_machine_pivot_missing')
  template.updateMatrixWorld(true)
  const origin = template.worldToLocal(machine.getWorldPosition(new Vector3()))
  // Preserve the supplied floor height; only recenter the horizontal pivot.
  return [origin.x, 0, origin.z]
}
export function courseStatusColor(alarmState) {
  return alarmState === 1 ? [1, 0.9142746, 0] : alarmState === 2 ? [1, 0, 0] : [0.072372116, 0.745283, 0]
}
export function courseStationLines(station) {
  const session = station.currentSession
  const person = session?.user || station.user
  const protectedUser = session?.userProtected || station.userProtected
  return [
    `${station.name} · ${station.id}`, station.description,
    `Online: ${station.onlineState ?? '—'}  State: ${station.state}  Alarm: ${station.alarmState}`,
    `Row: ${station.mapRow}  Column: ${station.mapColumn}  Position: ${station.mapPosition}`,
    `Session: ${session ? `${session.sessionId} / ${session.state}` : '—'}`,
    protectedUser ? 'User: Protected' : person ? `User: ${person.name} ${person.surname} (${person.userName})` : 'User: —',
  ].filter(Boolean)
}
